export default {"src":"/_next/static/media/TeaCafe.da2ece81.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};